import { FC, useContext, PropsWithChildren } from "react";

import { Navigate } from "react-router-dom";

import { AuthContext } from "@components/AuthProvider/contexts/Auth.context";

export const PrivateRoute: FC<PropsWithChildren> = ({ children }) => {
  const context = useContext(AuthContext);

  const {
    location: { pathname, search },
  } = window;
  if (!context?.user || !context.authUser)
    return <Navigate to={`/login?redirect=${pathname}${search}`} />;

  return <>{children}</>;
};
